module.exports = __webpack_public_path__ + "static/media/gabriel_marchidan.f6f5dc09.png";